import React from 'react';
import { Box, IconButton, Typography, Paper } from '@mui/material';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';

const SliderTimePanel = (props) => {

  const min = 0;
  const max = props.dates.length - 1;

  const handleLeft = () => {
    if (props.chooseNum > min) {
      props.setChooseNum(props.chooseNum - 1);
    }
  };

  const handleRight = () => {
    if (props.chooseNum < max) {
      props.setChooseNum(props.chooseNum + 1);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        backgroundColor: 'black',
        height: '30px'
        // borderRadius: '40px',
        // padding: '4px 8px',
      }}
    >
      {/* 左アイコン */}
      <IconButton
        sx={{
          color: 'white',
          backgroundColor: 'black',
          borderRadius: '50%',
          padding: 0,
          paddingRight: 1
        }}
        onClick={handleLeft}
        disabled={props.chooseNum === min}
      >
        <ChevronLeft />
      </IconButton>

      {/* 中央の表示部分 */}
      <Paper
        elevation={0}
        sx={{
          // marginX: 1,
          // // padding: '0px 16px',
          // borderRadius: 0,
          // borderLeft: '2px solid #000',
          // borderRight: '2px solid #000',
          backgroundColor: 'black',
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: 'bold',
            textAlign: 'center',
            whiteSpace: 'nowrap',
            color: 'white'
          }}
        >
          {props.selectDateTime}
        </Typography>
      </Paper>

      {/* 右アイコン */}
      <IconButton
        sx={{
          color: 'white',
          backgroundColor: 'black',
          borderRadius: '50%',
          padding: 0,
          paddingLeft: 1
        }}
        onClick={handleRight}
        disabled={props.chooseNum === max}
      >
        <ChevronRight />
      </IconButton>
    </Box>
  );
};

export default SliderTimePanel;
